/**
 * The fetch + mount half of the fragment pattern (docs/adr/2026-07-03-non-game-surface-rendering-model
 * — server-rendered Thymeleaf fragments are the standard rendering model for non-game surfaces,
 * HTMX rejected). Extracted at the third mounting copy (games-overlay.js, result-overlays.js,
 * dev/ai-lab-query.js all re-rolled the same ok-check + parse-and-move) — ahead of the ADR's literal
 * revisit trigger (a fourth+ copy diverging in shape) because the divergence it warns about had
 * already happened at three. `enhance()` stays with each caller: which enhance passes run, and how
 * many, is per-surface knowledge (games-overlay runs two, the others one).
 *
 * The fragments are trusted same-origin server-rendered HTML (Thymeleaf, our own controllers) —
 * innerHTML is fine here, unlike on untrusted input.
 *
 * mountFragment parses off-DOM (a detached container) and then moves the parsed nodes into `target`,
 * rather than assigning `target.innerHTML` directly — the ai-lab origin copy did the latter and never
 * picked up the refinement the two overlay copies converged on independently: parsing straight into a
 * live, attached node parses incrementally against that node's existing children, where a detached
 * container parses once, off-DOM, with nothing to interleave with.
 */

export function fetchFragment(url) {
  return fetch(url).then((r) => {
    if (!r.ok) throw new Error(`${url} failed: ${r.status}`);
    return r.text();
  });
}

/** `target` is a dedicated mount slot — this clears it. Never hand it a node carrying other
 *  chrome (a shell header, close actions): the wipe is the point, per-swap. */
export function mountFragment(target, html) {
  target.replaceChildren();
  const container = document.createElement("div");
  container.innerHTML = html;
  while (container.firstChild) target.appendChild(container.firstChild);
}
